import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eda5f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "dc-card-header" }
const _hoisted_5 = { class: "dc-card-header-defaut" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "访客计划", -1))
const _hoisted_8 = { class: "dc-card-header-defaut-subtitle" }
const _hoisted_9 = {
  key: 0,
  style: {"border-bottom":"1px dashed rgb(211, 218, 224)","margin-bottom":"12px"}
}
const _hoisted_10 = { class: "dc-card-header" }
const _hoisted_11 = { class: "dc-card-header-defaut" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_13 = { class: "dc-card-header-defaut-subtitle" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paddingLine" }, null, -1))
const _hoisted_15 = { class: "dc-card-header" }
const _hoisted_16 = { class: "dc-card-header-defaut" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商机", -1))
const _hoisted_19 = { class: "dc-card-header-defaut-subtitle" }

import { signInRecordListByCosId, listByParamCodes } from '@/api/common'
import { ref, reactive, computed, onMounted, watch, PropType } from 'vue'
import { useRoute } from 'vue-router'
import UploadFile from '@/components/UploadFile'
import { EnvironmentOutlined } from '@ant-design/icons-vue'
import VisitorProgramForm from '../../components/VisitorProgramForm.vue'
import { clueAndcustomerPhaseEnum, customerAllStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { followRecordsAddByMess, followRecordsAddOrUpdate, followRecordsDetail } from '@/api/yuntuSales/followUpManage'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import ConcatModal from '@/components/TabsContacts/lbu/editModal.vue'
import type { LbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { DcMessage } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import BusinessForm from '@/views/yuntuSales/chanceManage/business/components/BusinessForm.vue'
import CosDateTimeRagePicker from '@/components/CosDateTimeRagePicker/index.vue'
import { cloneDeep } from 'lodash-es'
import { goBack } from '@/hooks/cosRouter'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import dayjs from 'dayjs'

const __default__ = { name: 'BaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<LbuFollowUpRecordEdit>
  },
  view: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['update:detail', 'getDetail'],
  setup(__props, { emit: __emit }) {

const route = useRoute()
const props = __props
const concatModalRef = ref()

const initCos = ref(true)
const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
const customerRecord = ref<any>({})
const followUpOptions = reactive<{
  contactList: any[]
  saleChanceList: any[]
  visitPlanList: any[]
}>({
  contactList: [],
  saleChanceList: [],
  visitPlanList: []
})
const baseFormRef = ref()
const saleChanceFormRef = ref()
const hasSaleChance = ref(false)
const visitorProgramFormRef = reactive<any>({})
const form = ref<LbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: []
})
const resetValue = ref<LbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: []
})
const addConcatId = ref('')
const loading = ref(false)
const signInListOptions = ref([])
const getSignInList = async () => {
  try {
    const res: any =
      form.value.followRefId &&
      (await signInRecordListByCosId({ cosId: form.value.followRefId, signInId: form.value.signInId }))
    signInListOptions.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const emit = __emit
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
// 处理访客计划数据(只处理详情)
const visitPlanData = computed(() => {
  const { planId, planTitle } = form.value
  const { visitPlanList } = followUpOptions
  if (planId && planTitle && route.query.id) {
    const obj = visitPlanList.find((item: any) => item.id === planId)
    if (!obj) {
      visitPlanList.unshift({
        id: planId,
        title: planTitle,
        disabled: true
      })
    }
  }
  return visitPlanList
})
// 处理商机数据(只处理详情)
const saleChanceData = computed(() => {
  const { chanceId, chanceName } = form.value
  const { saleChanceList } = followUpOptions
  if (chanceId && chanceName && (route.query.id || route.query.planId)) {
    const obj = saleChanceList.find((item: any) => item.chanceId === chanceId)
    if (!obj) {
      saleChanceList.unshift({
        chanceId: chanceId,
        saleChanceName: chanceName,
        disabled: true
      })
    }
  }
  return saleChanceList
})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    followRecordsDetail(route.query.id)
      .then((res) => {
        form.value = res.data ? res.data : {}
        // emit('update:detail', res.data)
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 设置访客计划的ref
const setVisitorRef = (name: string, el: any) => {
  if (el) {
    visitorProgramFormRef[name] = el
  } else {
    delete visitorProgramFormRef[name]
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
// 新增客户联系人
const handleAddConcat = () => {
  if (!form.value.followRefId) {
    DcMessage.error('请先选择客户')
    return
  }
  concatModalRef.value.toggle()
}
// 联系人新增成功回调
const successConcat = (type: any, res: any) => {
  if (res.data) {
    addConcatId.value = res.data
  } else {
    addConcatId.value = ''
  }
  getMessage(form.value.followRefId, 'concat')
}
// 获取客户相关信息（访客计划，联系人，商机） type=concat：只获取联系人信息
const getMessage = (v: any, type: 'all' | 'concat' = 'all') => {
  followRecordsAddByMess({
    followRefId: v,
    planId: form.value.planId
  }).then((res) => {
    const { contactList, saleChanceList, visitPlanList } = res.data
    followUpOptions.contactList = contactList && contactList.length ? contactList : []
    if (type === 'concat') {
      // 填充默认值(新增的这条数据)
      const { contactId } = form.value
      if ((!contactId || contactId === -9) && contactList.length) {
        const c = contactList.find((v: any) => v.id === addConcatId.value)
        form.value.contactId = c?.id
        baseFormRef.value.clearValidate('contactId')
      }
    } else {
      followUpOptions.saleChanceList = saleChanceList && saleChanceList.length ? saleChanceList : []
      followUpOptions.visitPlanList = visitPlanList && visitPlanList.length ? visitPlanList : []
    }
  })
  if (type === 'all') {
    getSignInList()
  }
}

// 获取跟进相关信息
const changeCus = (v: any, option: any, init = false) => {
  initCos.value = false
  const { visitPlanList } = form.value
  visitPlanList?.forEach((item) => {
    item.visitRefId = v
    item.chanceId = undefined
  })
  form.value = {
    ...form.value,
    followRefId: v,
    saleChance: {
      ...form.value.saleChance,
      saleChanceRefId: v
    },
    visitPlanList,
    followStatus: option?.status,
    contactId: undefined,
    contactName: undefined,
    planId: undefined,
    chanceId: undefined
  }
}

// 获取跟进相关信息
const changePlan = (value: any) => {
  form.value.lbuVisitPurpose = value ? visitPlanData.value.find((e) => e.id === value)?.purpose : undefined
}
// 回显数据监听客户名称变化
watch(
  () => form.value.followRefId,
  (val) => {
    if (val) {
      getMessage(val)
    }
  },
  { immediate: true }
)
watch(
  () => customerRecord.value,
  (val) => {
    if (!initCos.value || !route.query.id) {
      form.value.followStatus = val?.status
      resetValue.value = cloneDeep(form.value)
    }
  },
  { immediate: true }
)
const changeContactId = (v: any, option: any) => {
  form.value.contactName = option ? option.name : undefined
}
// 提交表单
const handleSubmit = () => {
  const baseFormRefVali = baseFormRef.value?.validate()
  const saleChanceFormRefVali = saleChanceFormRef.value?.validate()
  const visitorProgramFormRefVali: any = []
  Object.values(visitorProgramFormRef).forEach((v: any) => {
    if (v) {
      visitorProgramFormRefVali.push(
        v
          .validate()
          .then((res: any) => res)
          .catch((res: any) => {
            if (!res.errorFields || !res.errorFields.length) {
              return res
            }
            return Promise.reject(new Error(res))
          })
      )
    }
  })
  Promise.all([baseFormRefVali, saleChanceFormRefVali, ...visitorProgramFormRefVali]).then(async (res) => {
    const p = {
      ...form.value,
      saleChance: hasSaleChance.value ? form.value.saleChance : undefined,
      visitPlanList: form.value.visitPlanList && form.value.visitPlanList.length ? form.value.visitPlanList : undefined
    }
    loading.value = true
    try {
      await followRecordsAddOrUpdate(p)
      if (route.query.planId) {
        DcMessage.success('已完成拜访')
      } else if (route.query.id) {
        DcMessage.success('编辑成功')
      } else {
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}
// 重置表单
const handleReset = () => {
  form.value.visitPlanList = []
  hasSaleChance.value = false
  form.value.saleChance = {}
}
// 校验访客计划表单
const validate = () => {
  Object.values(visitorProgramFormRef).forEach((v: any) => {
    if (v) {
      v.validate()
    }
  })
  saleChanceFormRef.value?.validate()
}
// 点击新增访客计划
const addVisitPlan = () => {
  if (!form.value.visitPlanList) {
    form.value.visitPlanList = []
  }
  form.value.visitPlanList.push({
    visitRefId: form.value.followRefId
  })
}
// 删除访客计划
const deleteVisitPlan = (index: number) => {
  form.value.visitPlanList?.splice(index, 1)
}
// 点击新增销售商机
const addSaleChance = () => {
  hasSaleChance.value = true
  form.value.saleChance = {
    saleChanceRefId: form.value.followRefId
  }
}
onMounted(() => {
  if (route.query.followRefId) {
    form.value = {
      followRefId: route.query.followRefId as string,
      chanceId: route.query.chanceId as string,
      saleChance: {
        saleChanceRefId: route.query.followRefId
      }
    }
    resetValue.value = cloneDeep(form.value)
  }
  if (form.value.startTime === undefined) {
    form.value.startTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
    form.value.endTime = form.value.startTime
  }
  fetch()
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      name: "detailsForm",
      ref_key: "baseFormRef",
      ref: baseFormRef,
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "跟进记录" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户名称",
              name: "followRefId",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(ClueAndCustomerSelect, {
                  appId: "cos_lbu",
                  value: form.value.followRefId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.followRefId) = $event)),
                  label: form.value.customerName,
                  "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerName) = $event)),
                  record: customerRecord.value,
                  "onUpdate:record": _cache[2] || (_cache[2] = ($event: any) => ((customerRecord).value = $event)),
                  disabled: _unref(route).query.followRefId || _unref(route).query.planId ? true : false,
                  onChange: changeCus,
                  view: __props.view
                }, null, 8, ["value", "label", "record", "disabled", "view"])
              ]),
              _: 1
            }),
            (__props.view)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.followRefId,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.followRefId) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户阶段" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.stage,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.stage) = $event)),
                        options: _unref(clueAndcustomerPhaseEnum),
                        allowClear: "",
                        placeholder: "请选择",
                        disabled: true,
                        view: __props.view
                      }, null, 8, ["value", "options", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "跟进方式",
              name: "mode",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.lbu_follow_mode,
                  value: form.value.mode,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.mode) = $event)),
                  label: form.value.lbuFollowTxt,
                  "onUpdate:label": _cache[6] || (_cache[6] = ($event: any) => ((form.value.lbuFollowTxt) = $event)),
                  view: __props.view
                }, null, 8, ["options", "value", "label", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "跟进时间",
              name: "startTime",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosDateTimeRagePicker, {
                  startTime: form.value.startTime,
                  "onUpdate:startTime": _cache[7] || (_cache[7] = ($event: any) => ((form.value.startTime) = $event)),
                  endTime: form.value.endTime,
                  "onUpdate:endTime": _cache[8] || (_cache[8] = ($event: any) => ((form.value.endTime) = $event)),
                  minuteStep: 15,
                  view: __props.view
                }, null, 8, ["startTime", "endTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进状态",
              name: "followStatus",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.followStatus,
                  options: _unref(customerAllStatusEnum),
                  allowClear: "",
                  placeholder: "请选择",
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: "contactId",
              label: "联系人",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contactId,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.contactId) = $event)),
                  fieldNames: {
            label: 'name',
            value: 'id'
          },
                  allowClear: "",
                  placeholder: "请选择",
                  onChange: changeContactId,
                  options: followUpOptions.contactList,
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "关联商机",
              name: "chanceId",
              rules: [{ required: [1024, 1020, 1022].includes(form.value.lbuVisitPurpose) && followUpOptions.saleChanceList.length > 0, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                (__props.view)
                  ? (_openBlock(), _createBlock(BusinessName, {
                      key: 0,
                      appId: "cos_lbu",
                      value: form.value.chanceName,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.chanceName) = $event))
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createBlock(_component_CosSelect, {
                      key: 1,
                      value: form.value.chanceId,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.chanceId) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      disabled: __props.disabled || _unref(route).query.chanceId ? true : false,
                      view: __props.view,
                      filterNoVal: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saleChanceData.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.chanceId,
                            disabled: item.disabled
                          }, {
                            default: _withCtx(() => [
                              _createVNode(BusinessName, {
                                appId: "cos_lbu",
                                value: item.saleChanceName,
                                "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled", "view"]))
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "完成访客计划",
              name: "planId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.planId,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.planId) = $event)),
                  fieldNames: {
            label: 'title',
            value: 'id'
          },
                  allowClear: "",
                  placeholder: "请选择",
                  options: visitPlanData.value,
                  disabled: __props.disabled || _unref(route).query.planId ? true : false,
                  view: __props.view,
                  onChange: changePlan,
                  filterNoVal: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "拜访目的",
              name: "lbuVisitPurpose",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择拜访目的' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.lbuVisitPurpose,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.lbuVisitPurpose) = $event)),
                  options: paramCodeData.value.lbu_follow_purpose,
                  disabled: __props.disabled,
                  view: __props.view,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "拜访签到记录",
              name: "signInId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  "show-search": "",
                  value: form.value.signInId,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.signInId) = $event)),
                  view: __props.view,
                  viewOptions: signInListOptions.value,
                  viewFieldNames: { label: 'signInTime', value: 'id' }
                }, {
                  view: _withCtx(({ option }) => [
                    (option && option.customerAddress)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          placement: "topLeft",
                          color: "rgba(19, 32, 67, 0.9)"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(option.customerAddress), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(option.signInTime || option.id) + " ", 1),
                              _createVNode(_unref(EnvironmentOutlined))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(option.signInTime || option.id || '--'), 1))
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(signInListOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            title: item.signInTime
                          }, _toDisplayString(item.signInTime), 9, _hoisted_1),
                          _createElementVNode("p", {
                            title: item.customerAddress,
                            style: {"color":"#999"}
                          }, _toDisplayString(item.customerAddress), 9, _hoisted_2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "view", "viewOptions"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "陪访人" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.lbuAccompanyPerson,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.lbuAccompanyPerson) = $event)),
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            (__props.view)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_dc_form_item, { label: "跟进人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.dutyByName,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.dutyByName) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createByName,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.createByName) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createTime,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.createTime) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "更新人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.updateByName,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.updateByName) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "更新时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.updateTime,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.updateTime) = $event)),
                        placeholder: "请输入",
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "目的",
              name: "lbuPurpose",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.lbuPurpose,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.lbuPurpose) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进过程",
              name: "process",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.process,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.process) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "当前遇到的问题",
              name: "problem",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.problem,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.problem) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "后续",
              name: "result",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.result,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.result) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "上传附件",
              name: "fileId",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: __props.view,
                  value: form.value.fileId,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.fileId) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(route).path.includes('/lbu/followUpRecord/add') || _unref(route).path.includes('/lbu/followUpRecord/visitingPlan'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: addVisitPlan,
                      ghost: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.visitPlanList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "page-card",
                  key: index
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("p", null, _toDisplayString(`访客计划${index + 1}`), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_button, {
                          danger: "",
                          onClick: ($event: any) => (deleteVisitPlan(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ]),
                  _createVNode(VisitorProgramForm, {
                    ref_for: true,
                    ref: (el) => setVisitorRef(`visitor${index}`, el),
                    saleChanceRefId: form.value.followRefId || '--',
                    value: form.value.visitPlanList[index],
                    "onUpdate:value": ($event: any) => ((form.value.visitPlanList[index]) = $event)
                  }, null, 8, ["saleChanceRefId", "value", "onUpdate:value"])
                ]))
              }), 128)),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    (hasSaleChance.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          danger: "",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (hasSaleChance.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "primary",
                          onClick: addSaleChance,
                          ghost: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增")
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              (hasSaleChance.value)
                ? (_openBlock(), _createBlock(BusinessForm, {
                    key: 0,
                    ref_key: "saleChanceFormRef",
                    ref: saleChanceFormRef,
                    type: "add",
                    value: form.value.saleChance,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.saleChance) = $event)),
                    saleChanceRefId: true
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form).value = $event)),
          formRef: baseFormRef.value,
          resetValue: resetValue.value,
          loading: loading.value,
          workCode: form.value.dutyBy,
          onValidate: validate,
          onReset: handleReset,
          permissionPage: __props.permissionPage,
          disabled: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: handleAddConcat }, {
              default: _withCtx(() => [
                _createTextVNode("新增联系人")
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              type: "primary",
              onClick: handleSubmit,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["loading"])), [
              [_directive_permission, __props.permissionPage.save]
            ])
          ]),
          _: 1
        }, 8, ["value", "formRef", "resetValue", "loading", "workCode", "permissionPage"]))
      : _createCommentVNode("", true),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: successConcat,
      contactRefId: form.value.followRefId,
      appId: "cos_lbu"
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})